import * as Sentry from '@sentry/react';
import { type ReactNode } from 'react';
import { ErrorFallback } from './ErrorFallback';
import type { PostureManagementTabType } from '../types';

interface PostureManagementErrorBoundaryProps {
  children: ReactNode;
  tab: PostureManagementTabType;
}

export function PostureManagementErrorBoundary({
  children,
  tab,
}: PostureManagementErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={<ErrorFallback label={`Something went wrong in ${tab} tab`} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
